<template>
  <div class="push-message-preview" style="border-radius: 8px;">
    <div class="whitespace-pre-line break-all flex flex-col" style="padding: 20px; gap: 20px">
      <div v-for="(message, index) in displayFlexMessages" :key="index">
        <p
          v-if="message.type === 'text'"
          class="text-message"
          v-html="convertUrlsToLinks(message.content)"
        />

        <div
          v-if="message.type === 'image'"
          @click="onImgClick(message)"
        >
          <img :src="message.imgSrc">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import { cleanHtml, imgSrc } from '@/utils/helper'

export default defineComponent({
  name: 'PushMessagePreview',
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const loading = ref(false)

    const displayFlexMessages = computed(() => {
      return props.messages.map((message, index) => {
        return {
          ...message,
          imgSrc: message.Image ? imgSrc(500, message.Image) : undefined,
        }
      })
    })

    const convertUrlsToLinks = (text) => {
      if (!text) return ''
      // 正則表達式匹配 http:// 或 https:// 開頭的 URL
      const urlRegex = /(https?:\/\/[^\s]+)/g
      return cleanHtml(text.replace(urlRegex, url => `<a href="${url}" target="_blank" style="color: var(--primary-100); text-decoration: underline;">${url}</a>`))
    }

    const onImgClick = (message) => {
      if (message.action === 'uri') {
        if (message.actionContent) {
          // create a tag to open the link
          window.open(message.actionContent, '_blank')
        }
      }
    }

    return {
      loading,
      displayFlexMessages,
      convertUrlsToLinks,
      onImgClick,
    }
  },
})
</script>

<style lang="postcss" scoped>
.push-message-preview {
  @apply w-full bg-[#849ebf];
}
.text-message {
    @apply text-gray-100 bg-white rounded-[20px] p-[12px];
  a {
    color: var(--primary-100) !important;
    text-decoration: underline !important;
  }
}

</style>
